var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/application/download",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "t5tk572cma"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/application/download (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/application/download (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/application/download",
    style: {
      clipPath: "url(#t5tk572cma)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/application/download (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/application/download (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.012 15.188H2.988a.563.563 0 0 1-.562-.562v-3.481a.141.141 0 0 1 .14-.141h1.06a.141.141 0 0 1 .14.141v2.707h10.473v-2.707a.141.141 0 0 1 .14-.141h1.055a.141.141 0 0 1 .14.141v3.48a.563.563 0 0 1-.562.563zm-6.011-3.514a.142.142 0 0 1-.062-.014.139.139 0 0 1-.049-.04L6.921 9.127a.14.14 0 0 1 .111-.227h1.294V2.953a.141.141 0 0 1 .145-.14h1.055a.141.141 0 0 1 .141.14v5.949h1.3a.14.14 0 0 1 .111.227L9.111 11.62a.147.147 0 0 1-.049.04.14.14 0 0 1-.061.014z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadM);
export default __webpack_public_path__ + "static/media/download_m.296318f828361104fd6be3f0d96fc82d.svg";
export { ForwardRef as ReactComponent };